import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { getResetByTag, utilityStyles, rem } from './../../../styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "bjn8wh",
  styles: "position:relative"
} : {
  name: "6q5ezk-defaultStyles",
  styles: "position:relative;label:defaultStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var defaultStyles = function defaultStyles() {
  return _ref;
};
var positioningStyles = function positioningStyles(_ref2) {
  var size = _ref2.size;
  var tops = {
    '2xs': 0,
    xs: 1,
    sm: 0.5,
    md: 0.2,
    lg: 0.75,
    xl: 1.2,
    '2xl': 1.8,
    '3xl': 2,
    '4xl': 2.2,
    '5xl': 0
  };
  if (tops[size] !== undefined) {
    return /*#__PURE__*/css("top:", rem(tops[size]), ";", size === '5xl' && /*#__PURE__*/css("@media (max-width: 768px){top:", rem(1), ";}" + (process.env.NODE_ENV === "production" ? "" : ";label:positioningStyles;")), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:positioningStyles;"));
  }
  return /*#__PURE__*/css("bottom:", rem(4), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:positioningStyles;"));
};
var inlinePositioning = function inlinePositioning(_ref3) {
  var size = _ref3.size,
    inline = _ref3.inline;
  if (inline && size) {
    return /*#__PURE__*/css("bottom:", rem(0), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:inlinePositioning;"));
  }
};
var resetStyles = getResetByTag('span');
var StyledPriceHyphen = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "e1uzchp80"
} : {
  target: "e1uzchp80",
  label: "StyledPriceHyphen"
})(resetStyles, positioningStyles, inlinePositioning, defaultStyles, utilityStyles);
export default StyledPriceHyphen;